/**
 * Canais de acesso (SPEC-20261008-1104-canais-de-acesso).
 *
 * Por onde a pessoa pode usar o Orbind: pelo NAVEGADOR, pelo DESKTOP
 * instalado ou pelo CELULAR. O workspace define o padrão; o colaborador pode
 * ter uma regra própria naquele workspace, que vence o padrão. Pedido do
 * Cristian (2026-10-08): "se exigir que seja pelo desktop sem ser pelo
 * navegador, ao logar ... disponibilizar o download e informa que o uso deve
 * ser pelo desktop sendo instalado o orbind na máquina".
 *
 * Mora no core porque API, web e o app de celular precisam da MESMA regra.
 */

export type CanalDeAcesso = 'navegador' | 'desktop' | 'celular'

export type CanaisDeAcesso = Record<CanalDeAcesso, boolean>

export const CANAIS_DE_ACESSO: readonly CanalDeAcesso[] = ['navegador', 'desktop', 'celular']

export const NOME_DO_CANAL: Record<CanalDeAcesso, string> = {
  navegador: 'Navegador',
  desktop: 'Desktop (aplicativo instalado)',
  celular: 'Celular e tablet',
}

/** O padrão de sempre: todo canal liberado. */
export const CANAIS_LIBERADOS: CanaisDeAcesso = { navegador: true, desktop: true, celular: true }

/**
 * Lê o que veio do banco (jsonb) sem confiar no formato: canal ausente ou
 * valor estranho conta como LIBERADO — uma coluna corrompida não pode trancar
 * todo mundo para fora.
 */
export function lerCanais(bruto: unknown): CanaisDeAcesso {
  const obj = bruto && typeof bruto === 'object' ? (bruto as Record<string, unknown>) : {}
  return {
    navegador: obj.navegador !== false,
    desktop: obj.desktop !== false,
    celular: obj.celular !== false,
  }
}

/** Ao menos um canal ligado — sem nenhum, ninguém entraria. */
export function temAlgumCanal(canais: CanaisDeAcesso): boolean {
  return CANAIS_DE_ACESSO.some((c) => canais[c])
}

/**
 * O que vale para a pessoa: a regra DELA no workspace, se houver; senão, o
 * padrão do workspace.
 */
export function canaisEfetivos(doWorkspace: unknown, doColaborador: unknown | null): CanaisDeAcesso {
  return doColaborador === null || doColaborador === undefined ? lerCanais(doWorkspace) : lerCanais(doColaborador)
}
